import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth';
import fetchYearsData from '../services/fetchYearsData';

export default function useYearsData() {
	const { accessToken } = useAuth();

	const yearsQuery = useQuery({
		queryKey: ['years'],
		queryFn: () => fetchYearsData(accessToken),

		staleTime: Infinity,
		retry: false,
	});

	return yearsQuery;
}
